<template>
    <rkm-modal
        large
        ref="Modal"
        title="Encerramento"
    >
        <rkm-form
            v-if="model"
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col :cols="model.motivoId === enums.motivo.OBITO ? 8 : 12">
                    <rkm-form-select
                        :options="form.motivos"
                        :validations="validations.motivo"
                        label="Motivo"
                        show-default-option
                        text-field="nome"
                        v-model="model.motivoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col v-if="model.motivoId === enums.motivo.OBITO">
                    <rkm-form-date-picker
                        :max-date="additionals.dataAtual"
                        :validations="validations.dataObito"
                        label="Data do óbito"
                        v-model="model.dataObito"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="model.motivoId === enums.motivo.CONCLUIDO">
                <rkm-col>
                    <rkm-form-select
                        :options="form.apacMotivosSaidaPermanencia"
                        :validations="validations.apacMotivoSaidaPermanencia"
                        label="Motivo de saída/permanêncoa (APAC)"
                        show-default-option
                        text-field="nome"
                        v-model="model.apacMotivoSaidaPermanenciaId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-textarea
                        :maxlength="validations.observacao.max"
                        :validations="validations.observacao"
                        label="Observações"
                        rows="4"
                        v-model="model.observacao"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="model.motivoId === enums.motivo.CONCLUIDO">
                <rkm-col cols="auto">
                    <rkm-button
                        @click="$refs.ModalSolicitacao.open(acompanhamentoOci)"
                        color="primary"
                    >
                        Visualizar solicitações
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Fechar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="$refs.Form.validate(save)"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>

        <ModalSolicitacao ref="ModalSolicitacao" />
    </rkm-modal>
</template>

<script>
// Components.
import ModalSolicitacao from '@/components/regulacao/monitoramento-protocolo/components/solicitacao/Modal'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

// Mixins.
import { repository, error, stringCase, object, data } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import acompanhamentoOciMotivoEncerramento from '@/enums/ambulatorio/acompanhamentoOciMotivoEncerramento'

export default {
    components: { ModalSolicitacao },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        validations() {

            return {
                motivo: { required: true },
                observacao: { min: 150, max: 500 },
                dataObito: { required: true },
                apacMotivoSaidaPermanencia: { required: true },
            }
        }
    },
    created() {
        this.repositories = {
            monitoramentoProtocolo: this.getConectaSusRepository('regulacao.monitoramentoProtocolo')
        }
    },
    data: () => ({
        acompanhamentoOci: null,
        additionals: null,
        form: null,
        model: null,
        others: { moment },
        enums: { motivo: acompanhamentoOciMotivoEncerramento }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {

            this.acompanhamentoOci = item

            this.resetForm()
            this.load()

            this.$refs.Modal.show()
        },
        load() {

            this.setLoading()

            this.repositories.monitoramentoProtocolo.createEncerramentoOci(this.acompanhamentoOci.id)
                .then(({ data }) => {

                    if (data.model.dataObito) {

                        data.model.dataObito = this.others.moment(data.model.dataObito, 'DD/MM/YYYY').toDate()
                    }

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        async save() {

            this.setLoading()

            try {

                if (this.model.motivoId === this.enums.motivo.CONCLUIDO) {

                    const dados = (await this.repositories.monitoramentoProtocolo
                        .dadosProcedimentosPreenchidos(this.acompanhamentoOci.id)).data

                    if (!dados.examesFinalizados) {
                        this.showValidationNotification(`Existem solicitações não realizadas ou procedimentos
                            realizados sem dados informados. Verifique antes de continuar.`)

                        return
                    }

                    if (dados.quantidadeConsultaLancada === 0) {
                        if (dados.procedimentoExigeSomenteUmaConsulta) {
                            this.showValidationNotification(`Não é possível concluir. Esta OCI exige uma consulta realizada.`)
                        }
                        else {
                            this.showValidationNotification(`Não é possível concluir. Esta OCI exige uma consulta inicial e de retorno realizada.`)
                        }

                        return
                    }

                    if (dados.quantidadeConsultaLancada === 1 && !dados.procedimentoExigeSomenteUmaConsulta) {
                        this.showValidationNotification(`Não é possível concluir. Esta OCI exige consulta de retorno e possui somente uma consulta realizada.`)

                        return
                    }
                }

                await this.repositories.monitoramentoProtocolo.storeEncerramentoOci(this.acompanhamentoOci.id, this.prepareData())

                this.showSaveNotification()
                this.$emit('save')
                this.$refs.Modal.hide()
            }
            catch (error) {

                this.handleError(error)
            }
            finally {

                this.unsetLoading()
            }
        },
        prepareData() {

            const data = this.clone(this.model)

            this.formateDates(data, ['dataObito'], 'DD/MM/YYYY')

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        resetForm() {

            this.additionals = null
            this.form = null
            this.model = null
        }
    },
    mixins: [repository, error, stringCase, object, data],
}
</script>